import { useClientsStore } from '@/stores/clients.store'
import { useGroupsStore } from '@/stores/groups.store'
import { useStatisticsStore } from '@/stores/statistics.store'
import { useFacturationStore } from '@/stores/facturation.store'

export function resetSessionStores(): void {
  useClientsStore.setState({ clients: null, isInitialized: false })
  useGroupsStore.setState({ groups: null, isInitialized: false })
  useFacturationStore.setState({
    invoices: null,
    selectedInvoice: null,
    isInitialized: false,
    isDetailLoading: false,
  })
  useStatisticsStore.setState({
    globalStatistics: null,
    clientsGraph: null,
    clientsStatusGraph: null,
    isLoading: false,
    isInitialized: false,
  })
}
